import ReactPlayer from 'react-player'

function AudioPlayer({url}) {
  return (
    // <ReactPlayer
    //   url={url}  // Replace with your URL
    //   controls
    //   playing={false}  // true = autoplay
    //   height="50px"    // makes it look like an audio bar
    //   width="100%"
    // />
    <audio controls style={{ height: '40px' }}  >
      <source src={url}/>
    </audio>
  )
}

export default AudioPlayer